import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// You can replace `any` with a proper type representing key data structure
type KeyItem = any;

interface EspKeyState {
  selectedKey: KeyItem | null;
  keysList: KeyItem[];
}

const initialState: EspKeyState = {
  selectedKey: null,
  keysList: [],
};

export const { actions: espKeyActions, reducer: espKeyReducer } = createSlice({
  name: "espKey",
  initialState,
  reducers: {
    setSelectedKey(state, action: PayloadAction<KeyItem | null>) {
      state.selectedKey = action.payload;
    },
    setKeys: {
      reducer(state, action: PayloadAction<KeyItem[]>) {
        state.keysList = action.payload;
      },
      prepare(list: KeyItem[]) {
        const sanitizedList = (list || []).map((keyItem: any) => {
          const copy: any = { ...keyItem };
          if (copy.validFrom instanceof Date) {
            copy.validFrom = copy.validFrom.toISOString();
          }
          if (copy.validTo instanceof Date) {
            copy.validTo = copy.validTo.toISOString();
          }
          return copy;
        });
        return { payload: sanitizedList } as const;
      },
    },
  },
});
